import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet, NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { Institution } from '../entities/institution.js';
import { Workshop } from '../entities/workshop.js';
import { getRecomendedWorkshopsAggregation } from '../server/logic/recommendations.js';
import { mongo } from '../server/mongo.js';

// logger.info(
//   { aggregation: getRecomendedWorkshopsAggregation('67360c9cc03623016595566e', null, DateTime.now()) },
//   'registered getWorkshopRecommendations',
// );

export const getWorkshopRecommendations = registerQuery({
  type: () => [Workshop],
  operationName: 'getWorkshopRecommendations',
  params: [
    { type: () => String, name: 'institutionID' },
    { type: () => String, name: 'userID' },
    { type: () => Int, name: 'limit' },
  ],
  resolve: (institutionID: Maybe<string>, userID: string, limit = 10) => {
    return async <SelSet extends BaseQLSelectionSet<Workshop>>(gqlFields: SelSet) => {
      const institutionCollection = mongo().collection(Institution._collectionName);
      const workshopAggregation = getRecomendedWorkshopsAggregation(userID, institutionID, new Date(), limit);
      const workshops = await institutionCollection.aggregate(workshopAggregation).toArray();

      return workshops as NarrowedEntity<Workshop, SelSet>[];
    };
  },
});
